module.exports = __webpack_public_path__ + "static/img/Nathan-Brown.4c84286.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Nathan-Brown.jpg
// module id = Dody
// module chunks = 0